export enum ExpeditionBlockedReasonEnum {
  RECIPIENT_ABSENT = "RECIPIENT_ABSENT",
  LAST_SCAN_TIME_EXCEEDED = "LAST_SCAN_TIME_EXCEEDED",
  LABEL_PRINTED_TIME_EXCEEDED = "LABEL_PRINTED_TIME_EXCEEDED",
  CLEARANCE_SCAN_TIME_EXCEEDED = "CLEARANCE_SCAN_TIME_EXCEEDED",
  CUSTOMS_ISSUE = "CUSTOMS_ISSUE",
  INCORRECT_ADDRESS = "INCORRECT_ADDRESS",
  PNC_ISSUE = "PNC_ISSUE",
  PARTIAL_DELIVERY = "PARTIAL_DELIVERY",
  TAX_NON_PAYMENT = "TAX_NON_PAYMENT",
  CUSTOMS_CLEARANCE_IN_PROGRESS = "CUSTOMS_CLEARANCE_IN_PROGRESS",
  RELAY_POINT = "RELAY_POINT",
  DAMAGED = "DAMAGED",
  RETURNED = "RETURNED",
  LOST_PACKAGE = "LOST_PACKAGE",
  UNKNOWN = "UNKNOWN",
  FEDEX = "FEDEX",
  DELAY = "DELAY",
  AUTO = "AUTO",
}
